import 'select2'
import {academicSlider} from "./academic-slider";

export default function studentAcademic() {
  let programData = JSON.parse(window.std_data.programData);
  $('.academic-program-select').select2();
  $('.academic-study-select').change(function (e) {
    const $this = $(this);
    const val = $this.val();

    displaySlidersOnStudyType(val);

    let options = ['<option value="">Select major/course</option>'];
    if (programData[val] !== undefined && programData[val].children !== undefined) {
      programData[val].children.map(function (el) {
        const opt = `<option value="${el.term_id}">${el.name}</option>`;
        options.push(opt)
      })
    }

    $('.academic-program-select').html(options)
    $('.academic-program-select').html(options).select2();
  });

  academicSlider.init('.academic-gpa-slider-1', 'input[name=academic_grade_gpa_scale1_state]', 1, 4, 0.1, '.academic-gpa-slider-2', 'input[name=academic_grade_gpa_scale2_state]');
  academicSlider.init('.academic-gpa-slider-2', 'input[name=academic_grade_gpa_scale2_state]', 65, 100, 1, '.academic-gpa-slider-1', 'input[name=academic_grade_gpa_scale1_state]');
  academicSlider.init('.academic-lang-toefl-slider', 'input[name=academic_lang_toefl_state]', 0, 120, 1);
  academicSlider.init('.academic-lang-ielts-slider', 'input[name=academic_lang_ielts_state]', 0, 9, 0.5);
  academicSlider.init('.academic-lang-itep-slider', 'input[name=academic_lang_itep_state]', 0, 6, 0.5);
  academicSlider.init('.academic-lang-duolingo-slider', 'input[name=academic_lang_duolingo_state]', 10, 160, 5);
  academicSlider.init('.academic-lang-pte-slider', 'input[name=academic_lang_pte_state]', 10, 90, 1);
  academicSlider.init('.academic-exams-sat-slider', 'input[name=academic_exams_sat_state]', 400, 1600, 10);
  academicSlider.init('.academic-exams-act-slider', 'input[name=academic_exams_act_state]', 1, 36, 1);
  academicSlider.init('.academic-exams-igcse-slider', 'input[name=academic_exams_igcse_state]', 1, 9, 1);
  academicSlider.init('.academic-exams-gmat-slider', 'input[name=academic_exams_gmat_state]', 200, 800, 10);
  academicSlider.init('.academic-exams-gre-slider', 'input[name=academic_exams_gre_state]', 130, 170, 1);

  checkFormToViewTheOptions();
  $('#edit-academic-form').change(function (e){
    $('#applywizard-view-options').addClass('disabled');
    checkFormToViewTheOptions(true);
  });

  updateOptionsURL();
  displaySlidersOnStudyType( $('.academic-study-select').val() );

  function checkFormToViewTheOptions(onChange = false) {
    const studyType = $('#academic_study_type').val();
    let msg = 'Please, save changes to view the options.';

    if (studyType === ''){
      msg = 'To view the options, please, select Degree you want to study and save the changes.'
    }

    updateOptionsURL();

    if (onChange || (!onChange && studyType === '') ) {
      $('#applywizard-view-msg').html(msg).show();
    }
  }
  function updateOptionsURL(){
    const studyType = $('#academic_study_type').val();
    const programs = $(".academic-program-select option:selected").toArray().reduce((acc, v) => {
      if (v.value) {
        acc.push(v.value);
      }
      return acc;
    }, []);
    const out = {
      study_type: studyType,
      show_eligible: 1,
      program: programs.join(','),
    };

    $.each(out, function(k, v) {
      if(v == ""){
        delete out[k];
      }
    });
    const url = $.param(out);

    $('#applywizard-view-options').attr('href', '/schools/?' +  url)
  }
  function displaySlidersOnStudyType(studyType) {
    const gmat = $('.gmat-slider-wrapper');
    const gre = $('.gre-slider-wrapper');
    const sat = $('.sat-slider-wrapper');
    const act = $('.act-slider-wrapper');
    const igcse = $('.igcse-slider-wrapper');

    gmat.hide();
    gre.hide();

    sat.show();
    act.show();
    igcse.show();

    if (studyType === '329'){ // Master's Degree
      gmat.show();
      gre.show();

      sat.hide();
      act.hide();
      igcse.hide();
    }
  }
}